export default __webpack_public_path__ + "static/media/cashflow_icon.3ce3e1e4.svg";